module.exports = __webpack_public_path__ + "assets/img/61d87ae033f837445d7a1658a99d2205.svg";